import { DateTimeRange } from '@routes/events/models/eventpage-model';
import moment from 'moment';

export enum ReportPeriodType {
    Undefined = 0,
    LastHour = 1,
    Last4Hour = 2,
    Last12Hour = 3,
    Last24Hour = 4,
    Last48Hour = 5,
    LastWeek = 6,
    Last2Weeks = 7,
    LastMonth = 8,
    Last3Month = 9,
    Last6Month = 10,
    LastYear = 11,
    Custom = 100,
}
